/**
 * Created by yoav.shmaria on 12/11/2017.
 */
import { swSettings } from "app/common/services/swSettings";
import { DefaultDataFetcher, fetchWithFullResponseConfig } from "./DefaultDataFetcher";

export class TopSitesTableDataFetcher extends DefaultDataFetcher<any> {
    private mode: any;

    constructor(widgetConfig) {
        super(widgetConfig);
        this.mode = swSettings.allowedCountry(this.widget.apiParams.country, "IndustryAnalysisGeneral")
            ? "extended"
            : "basic";
    }

    getParams(params = this.widget.apiParams) {
        const metric = this.mode === "extended" ? "TopSitesExtended" : "TopSites";
        this.widget.apiParams.metric = metric;
        const { properties } = this.widget.getWidgetConfig();
        return {
            ...params,
            metric,
            ...(!!properties.funcFlag && {
                funcFlag: properties.funcFlag,
            }),
        };
    }

    fetch(params = this.widget.apiParams) {
        return super.fetch(this.getParams(params));
    }

    protected getResource() {
        const metric = this.mode === "extended" ? "TopSitesExtended" : "TopSites";
        const controller = this.mode === "extended" ? "TopSitesExtended" : "TopSitesNew";
        return this.widgetResource.resourceByController(controller, metric, fetchWithFullResponseConfig)["Table"];
    }

    canAddToDashboard() {
        return true;
    }
}
